import * as React from 'react';
import { icons } from './constants';
import type { IconProps } from './types';

export default function UiIcon({ name }: IconProps) {
  const {
    path,
    width,
    height,
    viewBox,
  } = icons[name];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <title>{name}</title>
      <path
        fill="currentcolor"
        d={path}
      />
    </svg>
  );
}
